export const HEADER_HEIGHT = 85;
export const ICON_MEDIUM2_SIZE = 30;
export const TABS_HEIGHT = 64;
